import Menu from "./menu";

export class Setting {
    public adImagePath: string;
    public allYouCanEatKbn: {[key: string]: string}
    public checkoutInfoMessage: string;
    public checkoutInfoMessage_cn: string;
    public checkoutInfoMessage_en: string;
    public checkoutInfoMessage_kr: string;
    public hideCheckoutButton: string;
    public languageCn: string;
    public languageEn: string;
    public languageKr: string;
    public lastOrderKbn: string;
    public lastOrderLimitMinute: string;
    public menuMessages: string[];
    public multilingualItem: string;
    public onlySelectCategoryMenu: string;
    public orderLimitDrink: string;
    public orderLimitFood: string;
    public orderLimitLastOrder: string;
    public orderLimitTotal: string;
    public orderLimitType: string;
    public showHaizen: string;
    public taxDisplayType: string;
    public useLastOrder: string;
    public showRankingMobile: string;
    public showCallStaffMobile: string;
    public showNotAllYouCanEatMobile: string;
}

export class MenuSetting {
    public menus: Menu[];
    public allRawMenus: Menu[]; // for store all menu
    public setting: Setting;
}
